import { api } from "../components/stake/api";

export const shortenUrl = (url) => {
  const apiUrl = `https://tinyurl.com/api-create.php?url=${encodeURIComponent(
    url
  )}`;

  return api
    .get(apiUrl)
    .then((response) => {
      console.log("shortenUrl", { response });
      // Process the response and replace 'http://' with 'https://' if needed
      return response.data.replace("http://", "https://");
    })
    .catch((error) => {
      console.log("shortenUrl", { error });

      // Handle any errors
      throw error;
    });
};
